import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-asahenglish',
  templateUrl: './asahenglish.component.html',
  styleUrls: ['./asahenglish.component.scss']
})
export class AsahenglishComponent implements OnInit {

  constructor() { }

    ngOnInit(): void {
        window.scrollTo(0, 0);
    }

}
